import { render } from "./ServicesFive.vue?vue&type=template&id=7f9e8b32"
import script from "./ServicesFive.vue?vue&type=script&lang=js"
export * from "./ServicesFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__